module.exports = __webpack_public_path__ + "img/nt111-03-81-1.prt.8a2cc7ec.jpg";